'use client';

import type { ReactNode } from 'react';
import { cn } from '../_lib/utils';
import { isValidRichText } from '../_lib/isValidRichText';
import SparkleIcon from '../_assets/icons/sparkle.svg';
import { Text } from '../Text';

export type TipProps = {
	copy?: ReactNode;
	className?: string;
	name?: string;
};

export function Tip(props: TipProps) {
	return (
		<article className={cn('p-4 rounded-[0.5rem] flex flex-col gap-2 bg-background-secondary/10', props.className)}>
			<div className='flex flex-row items-center [&>svg]:w-[0.9rem] [&>svg]:text-text-label gap-2'>
				<SparkleIcon />
				{props.name && (
					<Text className='text-text-label' styleType='label-md'>
						{props.name}
					</Text>
				)}
			</div>
			{isValidRichText(props.copy) && <Text styleType='body-md'>{props.copy}</Text>}
		</article>
	);
}
